import { deleteDoc, doc } from "firebase/firestore";
import { firebaseDB } from "../../firebase";

export const useDeleteInvite = () => {
	const deleteInvite = async (inviteId: string) => {
		const inviteDoc = doc(firebaseDB, "invites", inviteId);
		await deleteDoc(inviteDoc);
	};
	return { deleteInvite };
};
